import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

import { computed, useSlots } from "vue";
import { ListItemProps } from "@/types";
import { useScreen } from "@/hooks";
import FlexBox from "@/components/common/display/content/FlexBox.vue";
import { Typography, Separator } from "../content";
import { Icon } from "../icon";


/**
 * Displays a generic list item.
 */
const __default__ = {
  name: "ListItem",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    title: {},
    subtitle: {},
    iconId: {},
    iconTitle: {},
    tooltip: { type: [Boolean, String] },
    to: {},
    divider: { type: Boolean },
    actionCols: {},
    clickable: { type: Boolean },
    icon: {},
    color: {},
    dataCy: {}
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const slots = useSlots();
const { smallWindow } = useScreen();

const itemClickable = computed(() => !!(props.clickable || props.to));

const itemTooltip = computed(() => {
  if (typeof props.tooltip === "string") {
    return props.tooltip;
  } else if (props.tooltip === true) {
    return props.subtitle ? `${props.title} - ${props.subtitle}` : props.title;
  } else {
    return undefined;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item = _resolveComponent("q-item")!

  return (_openBlock(), _createBlock(_component_q_item, {
    clickable: itemClickable.value,
    "v-ripple": !!props.to,
    to: props.to,
    "data-cy": _ctx.dataCy,
    dense: _unref(smallWindow),
    onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('click')))
  }, {
    default: _withCtx(() => [
      (!!props.tooltip)
        ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(itemTooltip.value), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!!props.icon || !!props.iconId || !!_unref(slots).icon)
        ? (_openBlock(), _createBlock(_component_q_item_section, {
            key: 1,
            avatar: ""
          }, {
            default: _withCtx(() => [
              _createVNode(FlexBox, {
                column: "",
                align: "center",
                justify: "center"
              }, {
                default: _withCtx(() => [
                  (!!props.icon || !!props.iconId)
                    ? (_openBlock(), _createBlock(_unref(Icon), {
                        key: 0,
                        id: props.iconId,
                        variant: props.icon,
                        color: props.color,
                        size: "sm"
                      }, null, 8, ["id", "variant", "color"]))
                    : _createCommentVNode("", true),
                  _renderSlot(_ctx.$slots, "icon"),
                  (!!props.iconTitle)
                    ? (_openBlock(), _createBlock(_unref(Typography), {
                        key: 1,
                        value: props.iconTitle,
                        variant: "small",
                        align: "center",
                        color: props.color
                      }, null, 8, ["value", "color"]))
                    : _createCommentVNode("", true)
                ]),
                _: 3
              })
            ]),
            _: 3
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_q_item_section, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_label, { class: "text-ellipsis" }, {
            default: _withCtx(() => [
              (!!props.title)
                ? (_openBlock(), _createBlock(_unref(Typography), {
                    key: 0,
                    value: props.title,
                    ellipsis: ""
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true),
              _renderSlot(_ctx.$slots, "default"),
              (props.divider)
                ? (_openBlock(), _createBlock(_unref(Separator), {
                    key: 1,
                    t: "1"
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 3
          }),
          (!!props.subtitle || !!_unref(slots).subtitle)
            ? (_openBlock(), _createBlock(_component_q_item_label, {
                key: 0,
                caption: "",
                class: "text-ellipsis"
              }, {
                default: _withCtx(() => [
                  (!!props.subtitle)
                    ? (_openBlock(), _createBlock(_unref(Typography), {
                        key: 0,
                        secondary: "",
                        value: props.subtitle,
                        ellipsis: ""
                      }, null, 8, ["value"]))
                    : _createCommentVNode("", true),
                  _renderSlot(_ctx.$slots, "subtitle")
                ]),
                _: 3
              }))
            : _createCommentVNode("", true)
        ]),
        _: 3
      }),
      (!!_unref(slots).actions)
        ? (_openBlock(), _createBlock(_component_q_item_section, {
            key: 2,
            class: _normalizeClass(props.actionCols ? `col-${props.actionCols}` : 'width-fit')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
              }, [
                _renderSlot(_ctx.$slots, "actions")
              ])
            ]),
            _: 3
          }, 8, ["class"]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["clickable", "v-ripple", "to", "data-cy", "dense"]))
}
}

})